export const form   =  [
 
/* 	{	
		name: "name", 
		value:'', 		
		id:'item_quickform_name',
		html:'',
		type:'textfield',
		required: true,  
	},
	{	
		name: "brand", 
		value:'', 		
		id:'item_quickform_brand',
		html:'',
		type:'textfield',
		required: false,   
	},
 */
]

//we use this for check changes on form	
export const formCopy = JSON.parse(JSON.stringify(form))